import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ChatWidget from '../../components/ChatWidget/ChatWidget';
import { LanguageProvider } from '../../context/LanguageContext/LanguageContext';

export default function PublicLayout() {
  return (
    <LanguageProvider>
      <div className="App">
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
        <ChatWidget />
      </div>
    </LanguageProvider>
  );
}
